import checkItem from './CheckItem';
var Checkbox = checkItem('checkbox');
export default Checkbox;